import React from "react";
import './Cartitems.css';
import CartService from '../Services/cart.service';
import AuthService from '../Services/auth.service';

//import CartService from '../Services/cart.service';
class DetailsSection extends React.Component {
    constructor(props){
        super(props);
        this.state = {
          
        }
       // console.log(props)
    }
    
    
   


       

    
    
    render() {
      //  console.log(this.props.menu)

      //const Maindes = this.props.menu.description
      const Subdes = this.props.menu.short_description
         return <div className="product-details-content">
                    <p className="reference">{this.props.menu.item_group}{/* <span> demo_17</span> */}</p> 
                    <h2>{this.props.menu.item_name}</h2>
                    <div className="pricing-meta">
                        <ul>

                            {/* <li className="old-price">$23.90</li> */}
                            <li className="cuttent-price rupay-font">₹ {this.props.menu.price}</li>
                        {/*  <li className="discount-flag">save 10%</li> */}
                        </ul>
                    </div>
                    <div className="pro-details-list">

                       <div dangerouslySetInnerHTML={{ __html:Subdes }} />
                        {/* <p>{this.props.menu.description}</p> */}
                    </div>
                    <div className="pro-details-quality mt-0px cart-product ">
                                    <div className="mr-5 mt-1 qty">
                                    <div className={this.props.showQty ? 'quantity-input counter-prdct ' : 'd-none '}>
                                        <button className="quantity-input__modifier quantity-input__modifier--left" onClick={this.props.subQty} addonType="prepend">
                                            &mdash;
                                        </button>
                                        <input className="quantity-input__screen" type="text" value={this.props.selectedQty} readonly />
                                        <button className="quantity-input__modifier quantity-input__modifier--right"  onClick={this.props.addQty} addonType="append">
                                        &#xff0b;
                                        </button>  
                                    </div>
                            
                                    </div>
                                  
                                    <div className="pro-details-cart btn-hover  shop-it-btn ">
                                        <button type="button" className={ this.props.stockStatus ? "add-to-cart2 btnn" : " btnn btn-secondary" } title="Add to cart" style={this.props.showQty ? { transform: 'scale(0)',transition:'all 1s ease 0s' } : { display: 'inline-block',transform: 'scale(1)' }} onClick={this.props.addToCart}>{this.props.btn}</button><br/>                                     
                                    </div>
                                 
                                  

                    </div>
                    
                </div>

       
  
                                 
        }
    }
    export default DetailsSection;